import { signalStoreFeature, withState } from '@ngrx/signals';

import { DEFAULT_REPORT_CONFIG } from '@core/const/attachment.const';
import { ReportConfig } from '@core/interfaces/report-config.interface';

interface ConfigState {
  config: ReportConfig;
}

export function withConfig() {
  return signalStoreFeature(
    withState<ConfigState>({
      config: DEFAULT_REPORT_CONFIG,
    }),
  );
}
